<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';

const props = defineProps<{
  type: 'phone' | 'email' | 'website';
  value: string;
  label?: string;
}>();

const iconMap = {
  phone: 'far fa-phone',
  email: 'far fa-envelope',
  website: 'far fa-globe',
} as const;

const href = computed(() => {
  switch (props.type) {
    case 'phone':
      return `tel:${props.value}`;
    case 'email':
      return `mailto:${props.value}`;
    case 'website':
      return props.value.startsWith('http') ? props.value : `https://${props.value}`;
    default:
      return props.value;
  }
});

const displayLabel = computed(() => props.label ?? props.value);
</script>

<template>
  <a
    :href="href"
    :target="props.type === 'website' ? '_blank' : undefined"
    :rel="props.type === 'website' ? 'noopener noreferrer' : undefined"
    class="flex items-center gap-2 text-primary hover:underline"
  >
    <FontAwesomeIcon :icon="iconMap[props.type]" class="text-grey-400" />
    {{ displayLabel }}
  </a>
</template>
